import type { ReactNode } from 'react'
import { useNotifier } from '@/lib/notifier'
import { shellStore } from '@/store/shellStore'
import { Spinner } from '@/components/ui/Spinner'

/* Port of the FFRoute.pageBuilder loading gate: while appStateNotifier.loading
 * (user == null || showSplashImage), every route renders a centred 50x50
 * primary spinner INSTEAD of the page.
 *
 * Deliberately no Scaffold equivalent: the spinner sits on the body's default
 * #FAFAFA (MaterialApp canvas), NOT on #F1F4F8. There is no splash image
 * despite the flag's name. */

export function LoadingGate({ children }: { children: ReactNode }) {
  const loading = useNotifier(shellStore, (s) => s.loading)

  if (loading) {
    return (
      <div
        data-gate="loading"
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--gate-bg)',
        }}
      >
        <Spinner size={50} color="var(--primary)" />
      </div>
    )
  }

  return <>{children}</>
}
